module.exports = __webpack_public_path__ + "img/11_no.36977e56.svg";